(() => {
  if (window.__folivisVideoRuntime) return;
  window.__folivisVideoRuntime = true;
  const players = () => [...document.querySelectorAll('[data-fv-video]')];
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const pauseOthers = (current) => players().forEach((player) => { const video = player.querySelector('video'); if (player !== current && video && !video.paused) video.pause(); });
  const load = (player) => {
    const video = player.querySelector('video');
    if (!video) return null;
    if (!video.querySelector('source')) { const source = document.createElement('source'); source.src = player.dataset.fvVideoSrc; source.type = 'video/mp4'; video.appendChild(source); video.load(); }
    return video;
  };
  const setup = (player) => {
    if (player.dataset.fvVideoBound === 'true') return;
    const video = player.querySelector('video');
    const toggle = player.querySelector('[data-fv-video-toggle]');
    const mute = player.querySelector('[data-fv-video-mute]');
    const error = player.querySelector('[data-fv-video-error]');
    if (!video || !toggle || !mute) return;
    player.dataset.fvVideoBound = 'true';
    const state = { manualPaused: false, ended: false, pending: false, inView: false };
    const update = () => {
      const playing = !video.paused && !video.ended;
      const playLabel = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
      toggle.setAttribute('aria-label', playLabel); toggle.title = playLabel;
      toggle.querySelector('[data-fv-video-toggle-icon]').setAttribute('d', playing ? 'M7 5h4v14H7zM13 5h4v14h-4z' : 'M8 5v14l11-7z');
      toggle.querySelector('[data-fv-video-toggle-text]').textContent = playing ? toggle.dataset.pauseText : toggle.dataset.playText;
      const muted = video.muted || video.volume === 0;
      const muteLabel = muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel;
      mute.setAttribute('aria-label', muteLabel); mute.title = muteLabel;
      mute.querySelector('[data-fv-video-mute-wave]').setAttribute('d', muted ? 'M17 9l4 6M21 9l-4 6' : 'M16 9.5c1.3 1.3 1.3 3.7 0 5');
      mute.querySelector('[data-fv-video-mute-text]').textContent = muted ? mute.dataset.unmuteText : mute.dataset.muteText;
      player.classList.toggle('is-playing', playing);
    };
    const start = (automatic = false) => {
      if (automatic && reducedMotion()) return;
      if (state.pending || state.manualPaused || state.ended || document.hidden || !state.inView) return;
      if (!video.paused && !video.ended) return;
      pauseOthers(player);
      const loaded = load(player);
      if (!loaded) return;
      if (!loaded.dataset.fvVideoInitialized) { loaded.muted = true; loaded.dataset.fvVideoInitialized = 'true'; }
      loaded.controls = false;
      state.pending = true;
      loaded.play().catch(() => {}).finally(() => { state.pending = false; if (!state.inView || document.hidden || state.manualPaused || state.ended) loaded.pause(); update(); });
    };
    toggle.addEventListener('click', () => { if (!video.paused && !video.ended) { state.manualPaused = true; video.pause(); } else { state.manualPaused = false; state.ended = false; start(false); } update(); });
    mute.addEventListener('click', () => { const loaded = load(player); if (!loaded) return; if (!loaded.dataset.fvVideoInitialized) { loaded.muted = true; loaded.dataset.fvVideoInitialized = 'true'; } loaded.muted = !loaded.muted; if (loaded.paused && !state.manualPaused && !state.ended) start(false); update(); });
    video.addEventListener('play', () => { pauseOthers(player); update(); });
    video.addEventListener('pause', update);
    video.addEventListener('volumechange', update);
    video.addEventListener('ended', () => { state.ended = true; update(); });
    video.addEventListener('error', () => { if (video.error) error.hidden = false; update(); });
    player.querySelector('[data-fv-video-retry]')?.addEventListener('click', () => { error.hidden = true; state.manualPaused = false; state.ended = false; load(player)?.load(); start(false); });
    toggle.dataset.playLabel ||= toggle.getAttribute('aria-label');
    update();
    player.__fvVideoVisible = (visible) => { state.inView = visible; if (visible) start(true); else if (!video.paused) video.pause(); };
    player.__fvVideoResume = () => { if (state.inView && !state.manualPaused && !state.ended && !reducedMotion()) start(true); };
  };
  const viewportVisible = (player) => { const rect = player.getBoundingClientRect(); return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth; };
  const init = () => {
    players().forEach(setup);
    if ('IntersectionObserver' in window) {
      if (!window.__folivisVideoObserver) window.__folivisVideoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => entry.target.__fvVideoVisible?.(entry.isIntersecting && entry.intersectionRatio >= 0.15)), { threshold: [0, 0.15, 0.5, 1] });
      players().forEach((player) => window.__folivisVideoObserver.observe(player));
    } else {
      const check = () => players().forEach((player) => player.__fvVideoVisible?.(viewportVisible(player)));
      if (!window.__folivisVideoViewportCheck) { let frame = 0; window.__folivisVideoViewportCheck = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; check(); }); }; window.addEventListener('scroll', window.__folivisVideoViewportCheck, { capture: true, passive: true }); window.addEventListener('resize', window.__folivisVideoViewportCheck); }
      check();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('visibilitychange', () => { if (document.hidden) players().forEach((player) => player.querySelector('video')?.pause()); else players().forEach((player) => player.__fvVideoResume?.()); });
  document.addEventListener('shopify:section:load', init);
})();
